<template>
  <v-app :class="{ 'full-screen': fullScreen }" id="app">
    <application-menu v-if="!fullScreen"></application-menu>
    <application-toolbar v-if="!fullScreen"></application-toolbar>
    <main>
      <v-dialog :value="true" v-if="currentChatPurchase" width="600px" lazy absolute persistent>
        <chat-popup :purchase="currentChatPurchase" />
      </v-dialog>
      <voip-call />
      <v-container class="container--full_height" :fluid="menuOpen" :fixed="!menuOpen">
        <router-view></router-view>
      </v-container>
    </main>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import soundNotification from '@/mixins/soundNotification'
  import ApplicationMenu from '@/components/ApplicationMenu'
  import ApplicationToolbar from '@/components/ApplicationToolbar'
  import ChatPopup from '@/components/purchase/popup/Availability'
  import VoipCall from '@/components/VoipCall'
  export default {
    components: {
      ApplicationMenu,
      ApplicationToolbar,
      ChatPopup,
      VoipCall
    },
    mixins: [soundNotification],
    computed: {
      ...mapGetters({
        menuOpen: 'application/menuOpen',
        isConnected: 'skiliko/session/connected',
        token: 'skiliko/session/token',
        needInformations: 'skiliko/session/needInformations',
        purchases: 'skiliko/purchases/collection'
      }),
      fullScreen () {
        return !this.isConnected || this.needInformations
      },
      currentChatPurchase () {
        return Object.keys(this.purchases)
          .map((key) => this.purchases[key])
          .filter((purchase) => purchase.offer.service_type === 'availability')
          .filter((purchase) => purchase.offer.service_options.availability_type === 'chat')
          .filter((purchase) => (purchase.accepted_at && purchase.service.start_at) || (purchase.payed_at && !purchase.accepted_at))[0]
      }
    },
    methods: mapActions({
      fetchCurrentUser: 'skiliko/session/currentUser',
      fetchCurrentPlatform: 'skiliko/session/currentPlatform'
    }),
    watch: {
      currentChatPurchase (current, previous) {
        (!previous && current)
          ? this.playNotification()
          : this.clear()
      }
    },
    mounted () {
      if (this.isConnected) {
        this.fetchCurrentPlatform({ token: this.token })
        this.fetchCurrentUser()
      }
    }
  }
</script>

<style lang="stylus">
  @import './theme'
</style>

<style lang="stylus" scoped>
  @import './variables'

  .full-screen {
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: $theme.primary!important;

    .container--full_height {
      height: auto;
    }
  }

  .container--full_height {
    height: "calc(100vh - %s)" % $toolbar-height;
    overflow: scroll;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue